import { createContext, useContext } from 'react';

interface StartChatWithPromptOptions {
  /** Used only when the agent has no department set in the chat, and never persisted there. */
  fallbackDepartment?: string;
}

export interface AiChatLauncherContextValue {
  isAvailable: boolean;
  startChatWithPrompt: (prompt: string, options?: StartChatWithPromptOptions) => void;
}

const AiChatLauncherContext = createContext<AiChatLauncherContextValue>({
  isAvailable: false,
  startChatWithPrompt: () => undefined,
});

export const AiChatLauncherProvider = AiChatLauncherContext.Provider;

export function useAiChatLauncher(): AiChatLauncherContextValue {
  return useContext(AiChatLauncherContext);
}
